import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAffirm = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 45,
	height: 22,
	viewBox: "0 0 45 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_5813_8024)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M2.95079 16.6684C2.39427 16.6684 2.11075 16.3943 2.11075 15.9439C2.11075 15.1038 3.0474 14.8214 4.75583 14.6397C4.75583 15.7591 3.99875 16.6684 2.94554 16.6684H2.95079ZM3.68583 10.3733C2.46462 10.3733 1.0607 10.9477 0.298362 11.5557L0.994547 13.0258C1.60568 12.4661 2.59378 11.9873 3.48527 11.9873C4.33266 11.9873 4.80099 12.2708 4.80099 12.842C4.80099 13.2253 4.49122 13.4195 3.90529 13.4962C1.71488 13.7797 -0.00195312 14.3845 -0.00195312 16.072C-0.00195312 17.4097 0.950444 18.2193 2.43837 18.2193C3.50102 18.2193 4.44607 17.6292 4.89549 16.8543V18.0093H6.87589V13.1696C6.87589 11.1745 5.49087 10.3691 3.68688 10.3691L3.68583 10.3733Z",
				fill: "#101820"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M23.5625 10.591V18.0002H25.6815V14.43C25.6815 12.7342 26.7085 12.2354 27.4235 12.2354C27.7455 12.2329 28.0609 12.3261 28.3297 12.5032L28.7172 10.5448C28.417 10.4246 28.0955 10.3664 27.7722 10.3736C26.6833 10.3736 25.9986 10.8556 25.5471 11.8364V10.591H23.5625Z",
				fill: "#101820"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M38.5367 10.373C37.4163 10.373 36.5783 11.0346 36.1426 11.673C35.7383 10.8487 34.8825 10.373 33.8535 10.373C32.7341 10.373 31.9581 10.9947 31.6 11.7108V10.5904H29.5566V17.9996H31.6777V14.1847C31.6777 12.8197 32.3949 12.1592 33.0638 12.1592C33.6697 12.1592 34.2262 12.5509 34.2262 13.5621V17.9996H36.3431V14.1847C36.3431 12.7997 37.0425 12.1592 37.7428 12.1592C38.3036 12.1592 38.8979 12.5666 38.8979 13.5474V17.9996H41.0148V12.8774C41.0148 11.2131 39.8944 10.373 38.5409 10.373",
				fill: "#101820"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.4056 10.5922H16.4861V9.83932C16.4861 8.85857 17.0458 8.57925 17.5277 8.57925C17.8568 8.58355 18.1804 8.66444 18.4728 8.81552L19.1259 7.32129C19.1259 7.32129 18.4633 6.88867 17.2589 6.88867C15.9054 6.88867 14.365 7.65206 14.365 10.0472V10.5922H11.1571V9.83932C11.1571 8.85857 11.7157 8.57925 12.1987 8.57925C12.5284 8.57923 12.8529 8.66037 13.1438 8.81552L13.7969 7.32129C13.4073 7.09343 12.7804 6.88867 11.931 6.88867C10.5774 6.88867 9.03701 7.65206 9.03701 10.0472V10.5922H7.81055V12.2261H9.04016V18.0014H11.1571V12.2261H14.3692V18.0014H16.4861V12.2261H18.4056V10.5922Z",
				fill: "#101820"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.7847 10.5918H19.6699V17.9978H21.7847V10.5918Z",
				fill: "#101820"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19.748 9.33207H21.8198C23.0284 5.53193 27.1289 2.19172 32.0053 2.19172C37.936 2.19172 43.0613 6.70694 43.0613 13.736C43.0794 15.1788 42.8812 16.6162 42.4733 18.0003H44.4841L44.5041 17.931C44.8429 16.5608 45.0101 15.1537 45.0018 13.7423C45.0018 5.90365 39.2895 0.261719 32.0095 0.261719C26.2909 0.261719 21.194 4.23092 19.7491 9.33417L19.748 9.33207Z",
				fill: "#4A4AF4"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5813_8024",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 45,
			height: 22,
			fill: "white"
		})
	}) })]
});
export default SvgAffirm;
